<fm-balloon-section class="polyline-balloon-date-section"
  [showDivider]="false">
  <div class="polyline-balloon-date-section__days">{{relativeDateFormatted}}</div>
  <div class="polyline-balloon-date-section__formatted-date">{{formattedDate}}</div>
</fm-balloon-section>
